const WidgetConfig = {
  // brand is optional if you want to use brandConfig from brandConfig.js
  brand: {
    id: 1585,
    name: "SEAGAIA",
    hotels: [
      {
        name: "シェラトン・グランデ・オーシャンリゾート",
        code: "01990300-f635-70db-8f54-d352c3c754cf",
        hotelId: 7574,
      },
      {
        name: "シーガイア・フォレスト・コンドミニアム",
        code: "01990301-d8ad-781c-b176-d7fbc85a5948",
        hotelId: 7576,
      },
    ],
  },
  tiers: true,
  lang: "ja",
  type: "rooms",
  hotelCode: "e6aac76dbdb814bc80a1b740e70d6ec0",
  showInventory: true,
  // Hides the per-child "bed / no bed" toggle in the room selector.
  // Shown by default; set to true only to remove it.
  disableBedOption: true, // process.env.VUE_APP_DISABLE_BED_OPTIONS === "true",
  rulesTitle: "小学生の添い寝について",
  rulesContent:
    "<li class='rules__item'> 大人1名様に対し、添い寝のお子様1名までとします。 </li><li class='rules__item'> 小学生の添い寝希望のお客様がご朝食をご希望の場合、現地にて別途1,500円（5歳～小学生）を頂戴いたします。 </li><li class='rules__item'> 小学生の添い寝の場合、幼児欄の「食事・布団不要」に人数をご入力の上、予約画面下の備考欄にお子様の年齢をご記載ください。 </li>",
};
console.log(' widget config', WidgetConfig, process.env.VUE_APP_DISABLE_BED_OPTIONS);
export default WidgetConfig;
